import { useBackend } from "../../services";

export const useDeleteEquipment = () => {
  const { deleteRequest } = useBackend();
  const deleteEquipment = (parameters: IDeleteEquipmentParameters) =>
    deleteRequest("equipments", parameters);
  return { deleteEquipment };
};

export interface IDeleteEquipmentParameters {
  uuid: string;
}
